import axios from '@/request/http'
import global from '@/constants/Global.constants'

export default {
  userUpdate (params) {
    return axios.post(global.BASE_ACL + '/user/updateUserInfo', params)
  },
  userDelete (params) {
    return axios.post(global.BASE_ACL + '/user/deleteUserInfo', params)
  },
  userInsert (params) {
    return axios.post(global.BASE_ACL + '/user/saveUserInfo', params)
  },
  userFindWhenUpdate (params) {
    return axios.post(global.BASE_ACL + '/user/findWhenUpdate', params)
  },
  userSelect () {
    return axios.post(global.BASE_ACL + '/user/findSelect')
  },
  insertTutor (params) { // 新增导师
    return axios.post(global.BASE_ACL + '/user/insertTutor', params)
  }
}



// WEBPACK FOOTER //
// ./src/request/user/userList.js